var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2199 2C12.2199 2 12.2199 2 12.2106 2C8.94074 2 5.2077 3.93635 4.23507 8.25805C3.14203 13.0849 6.06917 17.1727 8.71842 19.7545C9.33083 20.3496 10.5378 21.1985 11.3595 21.7531C11.8752 22.1012 12.5468 22.1022 13.0635 21.7555C13.8898 21.201 15.1045 20.3505 15.7121 19.7545C18.3613 17.1727 21.2885 13.0942 20.2047 8.26741C19.2413 3.93635 15.499 2 12.2199 2ZM11.9377 13.392C11.7576 13.5767 11.5294 13.6629 11.3013 13.6629C11.0732 13.6629 10.845 13.5767 10.6649 13.392L8.86386 11.5449C8.51566 11.1877 8.51566 10.5966 8.86386 10.2395C9.21207 9.88242 9.78841 9.88242 10.1366 10.2395L11.3013 11.434L15.4678 7.16095C15.816 6.80383 16.3923 6.80383 16.7405 7.16095C17.0888 7.51806 17.0888 8.10915 16.7405 8.46627L11.9377 13.392Z",
    fill: "#D5DAE0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.89d702a7945cf1375cabd4296109295a.svg";
export { ForwardRef as ReactComponent };